module.exports = __webpack_public_path__ + "static/img/app-slide-show4.8bcc68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/app-slide-show4.png
// module id = FXLt
// module chunks = 44